import { Link, useLocation } from "react-router-dom";
import { Plane } from "lucide-react";
import { AIR_BENGUE } from "@/lib/airBengue";

/**
 * Entrée de menu clignotante pour la nouvelle rubrique (demande du propriétaire :
 * une animation qui attire l'œil, intégrée au menu sombre existant).
 */
export const MenuAirBengue = () => {
  const { pathname } = useLocation();
  const actif = pathname.startsWith(AIR_BENGUE.route);

  return (
    <Link
      to={AIR_BENGUE.route}
      data-testid="nav-link-air-bengue"
      className={`group relative ml-1 inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-200 ${
        actif ? "text-white" : "text-[#A7BBFF] hover:text-white"
      }`}
      style={{
        background: actif ? AIR_BENGUE.color : AIR_BENGUE.colorSoft,
        boxShadow: actif ? `0 0 0 1px ${AIR_BENGUE.color}` : "none",
      }}
    >
      <span className="air-bengue-halo" aria-hidden="true" />
      <Plane size={14} className="shrink-0 -rotate-45" />
      <span className="relative">{AIR_BENGUE.court}</span>
      <span className="air-bengue-pastille relative rounded-full bg-[#FFD43B] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-[#12100E]">
        New
      </span>
    </Link>
  );
};
